import { getDialog } from './modals.js'
import { focusGuessInput } from './dom.js'

// Deferred a tick: a11y-dialog restores focus to whatever opened the
// dialog right after firing "hide", which would otherwise steal focus
// back from the guess input we just focused.
const dialog = getDialog('rules-modal')
if (dialog) {
    dialog.on('hide', () => {
        setTimeout(focusGuessInput, 0)
    })
}
